/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.createDepartment]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/department/add', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.departmentMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.departmentMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getDepartment]: ({ commit }, payLoad) => {
    let search
    let url=`/department/get?page=${payLoad.page}&limit=${payLoad.limit}`
    if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    if(payLoad.search){
      search = {search:payLoad.search}
      }
      else{
        search = {}
      }
    return httpClient
      .post(
        url,                                                                    
        search,
      ).then(
        (res) => {
          commit(storeMutations.setDepartmentMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.setDepartmentMutation, err);
          return err.response;
        },
      );
     
     
  },
  [storeActions.getDepartmentById]: ({ commit }, payLoad) => {
    console.log(payLoad.id);
    return httpClient.get('/department/getById/' + payLoad.id).then(
      (res) => {
        console.log(res);

        commit(storeMutations.departmentMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.departmentMutation, err);
        return err.response;
      },
    );
  },

  [storeActions.updateDepartmentById]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/department/update', payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };